/**
 * RFLXNS Interactive Card Gallery
 * - Scroll-triggered fan-out with IntersectionObserver
 * - Mouse parallax with Linear Interpolation (Lerp) in rAF
 */
(function () {
    'use strict';

    const section = document.getElementById('card-gallery');
    if (!section) return;

    const cards = section.querySelectorAll('.gallery-card');
    if (!cards.length) return;

    // ─── Fan-out layout: positions for each card ───
    const isMobile = () => window.innerWidth <= 768;

    function getFanPositions() {
        const mobile = isMobile();
        return [
            { x: mobile ? -110 : -340, y: mobile ? 30 : 40, rotate: -14, scale: mobile ? 0.85 : 0.82 },
            { x: mobile ? -50  : -170, y: mobile ? 10 : 15, rotate: -6,  scale: mobile ? 0.9  : 0.9  },
            { x: 0,                     y: 0,                rotate: 0,   scale: 1      },
            { x: mobile ? 50   : 170,  y: mobile ? 10 : 15, rotate: 6,   scale: mobile ? 0.9  : 0.9  },
            { x: mobile ? 110  : 340,  y: mobile ? 30 : 40, rotate: 14,  scale: mobile ? 0.85 : 0.82 },
        ];
    }

    // ─── State ───
    let isVisible = false;
    const mouse = { x: 0, y: 0 };   // target mouse normalized (-1..1)
    const current = [];              // current lerped transform per card
    cards.forEach(() => current.push({ x: 0, y: 0 }));

    // ─── Scroll-Triggered Fan-Out (IntersectionObserver) ───
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    isVisible = true;
                    section.classList.add('is-visible');
                    applyFanOut();
                } else {
                    isVisible = false;
                    section.classList.remove('is-visible');
                    resetCards();
                }
            });
        },
        { threshold: 0.25 }
    );
    observer.observe(section);

    function applyFanOut() {
        const positions = getFanPositions();
        cards.forEach((card, i) => {
            const p = positions[i];
            card.style.transform =
                `translate(${p.x}px, ${p.y}px) rotate(${p.rotate}deg) scale(${p.scale})`;
            card.style.opacity = '1';
        });
    }

    function resetCards() {
        cards.forEach((card) => {
            card.style.transform = 'translate(0px, 0px) rotate(0deg) scale(0.85)';
            card.style.opacity = '0';
        });
        current.forEach((c) => { c.x = 0; c.y = 0; });
    }

    // ─── Mouse Parallax ───
    section.addEventListener('mousemove', (e) => {
        const rect = section.getBoundingClientRect();
        mouse.x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;  // -1 to 1
        mouse.y = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
    });

    section.addEventListener('mouseleave', () => {
        mouse.x = 0;
        mouse.y = 0;
    });

    // Depth multipliers per card (center moves most, outer least)
    const depthMultipliers = [15, 25, 40, 25, 15];

    // ─── Lerp + rAF Loop ───
    const LERP_FACTOR = 0.08;

    function lerp(start, end, factor) {
        return start + (end - start) * factor;
    }

    function animate() {
        if (isVisible) {
            const positions = getFanPositions();

            cards.forEach((card, i) => {
                const depth = depthMultipliers[i];
                const targetX = mouse.x * depth;
                const targetY = mouse.y * depth;

                current[i].x = lerp(current[i].x, targetX, LERP_FACTOR);
                current[i].y = lerp(current[i].y, targetY, LERP_FACTOR);

                const p = positions[i];
                const finalX = p.x + current[i].x;
                const finalY = p.y + current[i].y;

                card.style.transform =
                    `translate(${finalX}px, ${finalY}px) rotate(${p.rotate}deg) scale(${p.scale})`;
            });
        }

        requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);

    // ─── Recalculate on resize ───
    window.addEventListener('resize', () => {
        if (isVisible) applyFanOut();
    });
})();
